
export default {

  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))

      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.pie      = json.pie
      this.timeline = json.timeline
      this.gantt    = json.gantt
      this.table    = json.table
      
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      if(this.gantt.display == 'Y') {
        this.timeline = {...this.timeline,
          week: [],
          month: [],
          year: [],
          scale: null,
          weekEnd: 'sunday'
        }
        this.gmx_TimelineValues_Gantt(this.timeline)
      }

      // Gantt
      if(this.gantt.display == 'Y') {
        this.gmx_tableCoordinates('x', this.gantt.columns, 5)
        this.gantt.width = this.gantt.columns[this.gantt.columns.length-1].ex
        this.gantt.length = this.gantt.width + this.timeline.length
      }

      // Table
      if(this.table.display == 'Y') {
        this.gmx_tableCoordinates('x', this.table.columns, 5)
        this.table.width = this.table.columns[this.table.columns.length-1].ex
      }

    },


  }
}